module.exports = __webpack_public_path__ + "img/logo.2b50ab77.png";